import { Outlet } from "react-router-dom";
import { useGetRole } from "../hooks/getRole";
import { NotFound } from "../../pages/NotFound";
import USER_ROLES from "../../types/UserRoles";

type ScopeProps = {
  admin?: boolean;
};

export const Scope = ({ admin = true }: ScopeProps) => {
  const [role, isAdmin] = useGetRole();

  if (admin) {
    return isAdmin && role !== USER_ROLES.INTEGRATION_RECEPTIONIST ? (
      <Outlet />
    ) : (
      <NotFound />
    );
  } else {
    return !isAdmin ? <Outlet /> : <NotFound />;
  }
};
